import Typography from '../../../shared/components/ui/Typography';

const PlatformsTableCell = (platforms: [string, string][]): JSX.Element => (
  <>
    {platforms.map((item, index) => (
      <Typography sx={{ display: 'block' }} key={index}>
        {item[0]} {item[1]}
      </Typography>
    ))}
  </>
);

export default PlatformsTableCell;
